import React from 'react';
import { useMap } from 'react-leaflet';
import './map-style.scss';
import { Icons } from '../BootstrapComponents/BootstrapComponents';

export function ZoomControls() {
  const map = useMap();

  return (
    <div className="zoom-controls">
      <button className="map-button" onClick={() => map.zoomIn()}>
        <Icons icon="zoom-plus" customIcon />
      </button>
      <button className="map-button" onClick={() => map.zoomOut()}>
        <Icons icon="zoom-minus" customIcon />
      </button>
    </div>
  );
}
